export const UpdateFeedConfig = {
    update: () => {}
}

export const updateFeedCache = (update) => {
    UpdateFeedConfig.update = update
}